import { AvailableComponents } from "./Components";

export default function Prices({ config }) {
  return (
    <div
      id="prices-section"
      className="prices-section"
      style={{
        backgroundColor: config.background?.color
          ? `var(--color-${config.background?.color})`
          : "transparent",
      }}
    >
      <div className="section-body">
        {config.content.map((content, i) => {
          const Component = AvailableComponents[content.type];
          if (!Component) return null;
          return <Component key={"component-" + i} config={content.settings} />;
        })}
      </div>
    </div>
  );
}
